import styled from 'styled-components';
import {Link} from 'gatsby';
import Typography from '../../constants/typography';

export const BackLink = styled(Link)`
  font-size: ${Typography.form.fontSize};
  width: max-content;
`;
